// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.shippingmethods.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/shippingmethods/shippingmethod/shippingmethod.tpl.html',
            controller: 'ShippingMethodController as vm'
        }},
        resolve: {
            shippingmethod: function() { return {}; },
            languages: languagesResolver,
            isNewShippingMethod: function() {return true;}
        }
    });

    $stateProvider.state('base.shippingmethods.shippingmethod', {
        url:'/{shippingmethodId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/shippingmethods/shippingmethod/shippingmethod.tpl.html',
            controller: 'ShippingMethodController as vm'
        }},
        resolve: {
            shippingmethod: shippingmethodResolver,
            languages: languagesResolver,
            isNewShippingMethod: function() {return false;}
        }
    });

}

// @ngInject
function shippingmethodResolver($stateParams, ShippingMethodsApiService) {
    return ShippingMethodsApiService.getShippingMethod($stateParams.shippingmethodId);
}

// @ngInject
function languagesResolver($stateParams, ShippingMethodsApiService) {
    return ShippingMethodsApiService.getLanguages();
}

// @ngInject
function ShippingMethodController($state, shippingmethod, loadSpinnerService, ShippingMethodsApiService, ToasterService, confirmationDialogService, $translate, isNewShippingMethod, languages) {
    var vm = this;

    var shippingmethodCopy = {};

    vm.shippingmethod = shippingmethod;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveShippingMethod = saveShippingMethod;
    vm.deleteShippingMethod = deleteShippingMethod;

    vm.isNewShippingMethod = isNewShippingMethod;
    vm.isEditing = vm.isNewShippingMethod;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactShippingMethodView') !== 'false';
    vm.reactShippingMethodId = isNewShippingMethod ? null : (shippingmethod && shippingmethod.id != null ? shippingmethod.id : null);

    vm.isShippingMethodCodeValid = isShippingMethodCodeValid;
    vm.isAllInformationValid = isAllInformationValid;
    vm.languages = languages;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewShippingMethod) {
            vm.shippingmethod = {};
        }

        appendLocalizations(vm.shippingmethod, vm.languages);

    }

    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function enableEditing() {
        shippingmethodCopy = angular.copy(vm.shippingmethod);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.shippingmethod = shippingmethodCopy;
        vm.isEditing = false;
    }

    function saveShippingMethod() {
        if (vm.isNewShippingMethod) {
            saveNewShippingMethod();
        } else {
            updateShippingMethod();
        }
    }

    function saveNewShippingMethod() {
        loadSpinnerService.start('mainSpinner');
        ShippingMethodsApiService.createShippingMethod(vm.shippingmethod).then(function(response) {
            vm.shippingmethod = response;
            prepareData();
            vm.isNewShippingMethod = false;
            vm.isEditing = false;
            $state.go('base.shippingmethods.shippingmethod', {shippingmethodId: vm.shippingmethod.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateShippingMethod() {
        loadSpinnerService.start('mainSpinner');

        ShippingMethodsApiService.updateShippingMethod(vm.shippingmethod).then(function(response) {
            vm.shippingmethod = response;
            prepareData();
            vm.isNewShippingMethod = false;
            vm.isEditing = false;
            $state.go('base.shippingmethods.shippingmethod', {shippingmethodId: vm.shippingmethod.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteShippingMethod() {
        confirmationDialogService
            .showDialog($translate.instant('shippingmethod.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    ShippingMethodsApiService.deleteShippingMethod(vm.shippingmethod.id).then(function(response) {
                        vm.shippingmethod = response;
                        prepareData();
                        vm.isNewShippingMethod = false;
                        vm.isEditing = false;
                        $state.go('base.shippingmethods');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(shippingmethod) {
        shippingmethod.showEditForm = !shippingmethod.showEditForm;
    }

    function prepareData() {
        if (vm.shippingmethod === undefined) {
            return;
        }

        vm.shippingmethodCopy = angular.copy(vm.shippingmethod);
    }

    function isAllInformationValid() {
        return isShippingMethodCodeValid();
    }

    function isShippingMethodCodeValid() {
        if (!vm.shippingmethod.code) { return false; }
        if (vm.shippingmethod.code.length > 20) { return false; }

        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('shippingmethods.shippingmethod', [])
    .config(stateConfig)
    .controller('ShippingMethodController', ShippingMethodController);
